import {AndroidDeviceDependencies} from '../types';
import {androidBridge} from '../messageBridge';
import {infoMessage} from 'interactors/messageBus/create';

export function updateWidget(data: DeviceWidgetData, di: AndroidDeviceDependencies = {}): void {
  const {bridge = androidBridge} = di;
  const message = infoMessage('update-widget', data);
  bridge.sendMessage?.(message);
}
